import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Chip
} from "@mui/material";

const CleanerApp = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Chip 
          label="Page Category" 
          sx={{ 
            mb: 3,
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 3,
            fontSize: { xs: "2.5rem", md: "3rem" }
          }}
        >
          Page Title
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem"
          }}
        >
          Page content goes here. This is a placeholder that you can replace with 
          actual content specific to this page.
        </Typography>
      </Box>

      {/* Add more sections as needed */}
    </Container>
  );
};

export default CleanerApp;